import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useRegisterDataIntegrationStepControls } from 'src/features/Signup/hooks/useRegisterDataIntegrationStepControls';
import { DataUploadStepWrapper } from 'src/features/Signup/components/templates/DataIntegrationFlow/steps/DataUploadStep';
import {
  getStepIndex,
  getNextStepPath,
  getPrevStepPath,
} from 'src/features/Signup/utils/dataIntegrationSteps';

const nextPath = getNextStepPath('data-upload');
const prevPath = getPrevStepPath('data-upload');

export const DataUploadStepRoute: React.FC = () => {
  const navigate = useNavigate();

  useRegisterDataIntegrationStepControls({
    title: 'Upload your data',
    subtitle:
      'Please upload your marketing data and KPI/Sales data, so our AI can analyze performance and provide actionable insights',
    currentStep: getStepIndex('data-upload'),
    onNext: nextPath ? () => navigate(nextPath) : undefined,
    onBack: prevPath ? () => navigate(prevPath) : undefined,
    isBackDisabled: false,
    isNextDisabled: false,
  });

  return <DataUploadStepWrapper />;
};
